import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=6b8a6cf2&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=ts"
export * from "./UserPicker.vue?vue&type=script&lang=ts"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=6b8a6cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a6cf2",
  null
  
)

export default component.exports